<app-header></app-header>
<app-home></app-home>
<app-professional></app-professional>
<app-portfolio></app-portfolio>
<app-experience></app-experience>
<app-courses></app-courses>
<app-footer></app-footer>